import { IPlayer } from 'interfaces/team/IPlayer';
import React, { useState } from 'react';
import StrikeZoneMissingModal from './StrikeZoneMissingModal';
import { Badge, Description, StrikeZoneMissingWrapper, StyledInfoIcon } from './StrikeZoneMissingStyles';

interface IProps {
  players: IPlayer[];
}

const StrikeZoneMissing: React.FC<IProps> = (props) => {
  const { players } = props;
  const [visible, setVisible] = useState(false);

  return (
    <StrikeZoneMissingWrapper>
      <Badge>SZ</Badge>
      <Description>
        Player(s) missing SZ data <StyledInfoIcon onClick={() => setVisible(true)} />
      </Description>
      <StrikeZoneMissingModal setVisible={setVisible} visible={visible} players={players} />
    </StrikeZoneMissingWrapper>
  );
};

export default StrikeZoneMissing;
